// RSN Gloves Catalog

const IMG = {
  // Existing Rubber Hand Gloves
  softcareFront:
    "/images/products/softcare-front.png",
  softcareBack:
    "/images/products/softcare-back.png",
  guarduraFront:
    "/images/products/guardura-front.png",
  guarduraBack:
    "/images/products/guardura-back.png",
  goldTouch:
    "/images/products/gold-touch.png",
  prideFront:
    "/images/products/pride-front.png",
  prideOriginal:
    "/images/products/pride-original.png",
  aaFront:
    "/images/products/aa-premium-front.png",
  aaBack:
    "/images/products/aa-premium-back.png",

  // Cotton Hand Gloves
  knittedBlue: "/images/products/knitted-hand-gloves-blue.webp",
  knittedWhite: "/images/products/knitted-hand-gloves-white.webp",

  knittedDottedBlue: "/images/products/knitted-dotted-blue.webp",
  knittedDottedWhite: "/images/products/knitted-dotted-white.webp",

  jeans: "/images/products/jeans-hand-gloves.webp",
  jeansLeather: "/images/products/jeans-leather-hand-gloves.webp",
  canvas: "/images/products/canvas-hand-gloves.webp",
  canvasLeather: "/images/products/canvas-leather-hand-gloves.webp",

  // Commercial Coated Gloves
  commercialGreyWhite: "/images/products/commercial-grey-white.webp",
  commercialOrangeYellow: "/images/products/commercial-orange-yellow.webp",

  // Spectrum Cut Resistant Gloves
  vira: "/images/products/spectrum-vira-n-prime.webp",
  soma: "/images/products/spectrum-soma.webp",
  karveer: "/images/products/spectrum-karveer.webp",
  ballad: "/images/products/spectrum-ballad.webp",
  chola: "/images/products/spectrum-chola.webp",
  deva: "/images/products/spectrum-deva.webp",
};

export const PRODUCTS = [
  // =========================================================
  // RUBBER HAND GLOVES
  // =========================================================

  {
    slug: "softcare",
    name: "Softcare Gloves",
    productCategory: "Rubber Hand Gloves",
    series: "Lightweight",
    tagline: "Lightweight rubber gloves â€” comfortable for daily use",
    image: IMG.softcareFront,
    gallery: [IMG.softcareFront, IMG.softcareBack],
    moq: "500 pairs",
    pricePerPair: "Best Bulk Price",
    category: "Natural Latex",
    color: "Orange / Black",
    material: "Natural Latex (Multi-Purpose)",
    weight: "â‰ˆ 100 gm",
    sizes: ["S", "M", "L", "XL"],
    applications: [
      "Civil & cleaning work",
      "General industrial use",
      "Pharmaceutical & chemical",
      "Household / agriculture",
    ],
    features: [
      "Lightweight & comfortable for daily use",
      "Good grip for wet & dry work",
      "Long-lasting rolled cuff, non-slip grip",
      "Reusable â€” rinse & air-dry",
    ],
    pack: "1 pair / pack Â· Made in India",
    leadTime: "5â€“7 working days",
  },

  {
    slug: "guardura",
    name: "Guardura Gloves",
    productCategory: "Rubber Hand Gloves",
    series: "Heavy-Duty",
    tagline: "Heavy-duty rubber protection â€” rugged industrial use",
    image: IMG.guarduraFront,
    gallery: [IMG.guarduraFront, IMG.guarduraBack],
    moq: "500 pairs",
    pricePerPair: "Best Bulk Price",
    category: "Natural Latex",
    color: "Orange / Black",
    material: "Flocklined Natural Latex (Heavy)",
    weight: "â‰ˆ 130 gm",
    sizes: ["M", "L", "XL"],
    applications: [
      "Heavy industrial applications",
      "Pharmaceutical & chemical",
      "Mechanical works",
      "Agriculture & construction",
    ],
    features: [
      "Heavy-duty rubber protection",
      "Strong grip & superior durability",
      "Comfortable fit for long working hours",
      "Strong protection Â· highly durable Â· comfort grip",
    ],
    pack: "1 pair / pack Â· Made in India",
    leadTime: "7â€“10 working days",
  },

  {
    slug: "gold-touch",
    name: "Gold Touch Gloves",
    productCategory: "Rubber Hand Gloves",
    series: "Premium",
    tagline: "Premium quality rubber â€” flexible & precise",
    image: IMG.goldTouch,
    gallery: [IMG.goldTouch],
    moq: "500 pairs",
    pricePerPair: "Best Bulk Price",
    category: "Flocklined Latex",
    color: "Multiple colours available",
    material: "Natural Latex Flocklined Rubber",
    weight: "â‰ˆ 70 gm",
    sizes: ["M", "L"],
    applications: [
      "Workshops & precision work",
      "Industrial use",
      "Mechanical handling",
      "General manufacturing",
    ],
    features: [
      "Premium rubber finish",
      "Flexible & comfortable handling",
      "Enhanced grip for precision work",
      "Durable for repeated usage",
    ],
    pack: "1 pair / pack Â· Made in India",
    leadTime: "5â€“8 working days",
  },

  {
    slug: "pride",
    name: "Pride Gloves",
    productCategory: "Rubber Hand Gloves",
    series: "Everyday",
    tagline: "Reliable everyday protection â€” economical & durable",
    image: IMG.prideFront,
    gallery: [IMG.prideFront, IMG.prideOriginal],
    moq: "1,000 pairs",
    pricePerPair: "Best Bulk Price",
    category: "Natural Latex",
    color: "Orange / Green",
    material: "Natural Latex",
    weight: "â‰ˆ 45 gm",
    sizes: ["S", "M", "L"],
    applications: [
      "Industrial & warehouse",
      "Utility work",
      "Loading / unloading",
      "General-purpose tasks",
    ],
    features: [
      "Reliable protection for everyday tasks",
      "Comfortable hand fit & flexibility",
      "Good resistance for general-purpose work",
      "Durable & economical option",
    ],
    pack: "1 pair / pack Â· Made in India",
    leadTime: "3â€“5 working days",
  },

  {
    slug: "aa-premium",
    name: "A&A Premium Gloves",
    productCategory: "Rubber Hand Gloves",
    series: "Premium",
    tagline: "Premium virgin rubber â€” superior strength & flexibility",
    image: IMG.aaFront,
    gallery: [IMG.aaFront, IMG.aaBack],
    moq: "500 pairs",
    pricePerPair: "Best Bulk Price",
    category: "Premium Virgin Rubber",
    color: "Premium Orange",
    material: "Premium Virgin Rubber",
    weight: "Heavy-duty",
    sizes: ["M", "L", "XL"],
    applications: [
      "Heavy-duty industrial",
      "Foundry & welding workshops",
      "Pharmaceutical & chemical",
      "Construction & demolition",
    ],
    features: [
      "Made from premium virgin rubber",
      "Superior strength & flexibility",
      "Comfortable fit Â· enhanced durability",
      "Premium-quality protection for professionals",
    ],
    pack: "1 pair / pack Â· Made in India",
    leadTime: "7â€“10 working days",
  },

  // =========================================================
  // COTTON HAND GLOVES
  // =========================================================

  {
    slug: "knitted-hand-gloves",
    name: "Knitted Hand Gloves",
    productCategory: "Cotton Hand Gloves",
    series: "Knitted",
    tagline:
      "Cotton knitted gloves for general handling and industrial applications",
    image: IMG.knittedBlue,
    gallery: [IMG.knittedBlue, IMG.knittedWhite],
    moq: "1 bag",
    pricePerPair: "Best Bulk Price",
    category: "Knitted Hand Gloves",
    color: "Blue / White",
    material: "Cotton Knitted",
    weight: "40 gm / 70 gm",
    gauge: "7 Gauge",
    sizes: ["23 cm"],
    variants: {
      weight: ["40 gm", "70 gm"],
      color: ["Blue", "White"],
    },
    applications: [
      "General material handling",
      "Industrial use",
      "Warehouse operations",
      "Packing & handling",
    ],
    features: [
      "7 Gauge knitted construction",
      "Available in 40 gm and 70 gm",
      "Available in blue and white",
      "23 cm size",
    ],
    pack: "1,200 pairs / bag",
    leadTime: "Ask for availability",
  },

  {
    slug: "knitted-dotted-hand-gloves",
    name: "Knitted Dotted Hand Gloves",
    productCategory: "Cotton Hand Gloves",
    series: "Knitted Dotted",
    tagline: "Knitted gloves with dotted grip for improved material handling",
    image: IMG.knittedDottedBlue,
    gallery: [IMG.knittedDottedBlue, IMG.knittedDottedWhite],
    moq: "1 bag",
    pricePerPair: "Best Bulk Price",
    category: "Knitted Dotted Hand Gloves",
    color: "Blue / White",
    material: "Cotton Knitted with Dotted Grip",
    weight: "45 gm",
    gauge: "7 Gauge",
    sizes: ["23 cm"],
    variants: {
      color: ["Blue", "White"],
    },
    applications: [
      "Material handling",
      "Warehouse operations",
      "Packing & sorting",
      "General industrial use",
    ],
    features: [
      "7 Gauge knitted construction",
      "45 gm weight",
      "Dotted surface for improved grip",
      "Available in blue and white",
    ],
    pack: "900 pairs / bag",
    leadTime: "Ask for availability",
  },

  {
    slug: "jeans-hand-gloves",
    name: "Jeans Hand Gloves",
    productCategory: "Cotton Hand Gloves",
    series: "Fabric",
    tagline:
      "Durable fabric hand protection for general industrial handling",
    image: IMG.jeans,
    gallery: [IMG.jeans],
    moq: "1 bag",
    pricePerPair: "Best Bulk Price",
    category: "Jeans Hand Gloves",
    color: "",
    material: "Jeans Fabric",
    weight: "",
    sizes: ["11 inches"],
    applications: [
      "Material handling",
      "Industrial use",
      "Workshop operations",
      "General-purpose work",
    ],
    features: [
      "Jeans fabric construction",
      "11 inch size",
      "Suitable for general industrial handling",
    ],
    pack: "500 pairs / bag",
    leadTime: "Ask for availability",
  },

  {
    slug: "jeans-leather-hand-gloves",
    name: "Jeans Leather Hand Gloves",
    productCategory: "Cotton Hand Gloves",
    series: "Leather Reinforced",
    tagline:
      "Jeans fabric gloves with leather reinforcement for demanding handling work",
    image: IMG.jeansLeather,
    gallery: [IMG.jeansLeather],
    moq: "1 bag",
    pricePerPair: "Best Bulk Price",
    category: "Jeans Leather Hand Gloves",
    color: "",
    material: "Jeans Fabric / Leather",
    weight: "",
    sizes: [],
    applications: [
      "Material handling",
      "Industrial use",
      "Workshop operations",
    ],
    features: [
      "Jeans fabric construction",
      "Leather reinforcement",
    ],
    pack: "500 pairs / bag",
    leadTime: "Ask for availability",
  },

  {
    slug: "canvas-hand-gloves",
    name: "Canvas Hand Gloves",
    productCategory: "Cotton Hand Gloves",
    series: "Fabric",
    tagline:
      "Canvas hand protection for general industrial and material handling applications",
    image: IMG.canvas,
    gallery: [IMG.canvas],
    moq: "1 bag",
    pricePerPair: "Best Bulk Price",
    category: "Canvas Hand Gloves",
    color: "",
    material: "Canvas Fabric",
    weight: "",
    sizes: [],
    applications: [
      "Material handling",
      "Industrial use",
      "General-purpose work",
    ],
    features: [
      "Canvas fabric construction",
      "Suitable for general material handling",
    ],
    pack: "500 pairs / bag",
    leadTime: "Ask for availability",
  },

  {
    slug: "canvas-leather-hand-gloves",
    name: "Canvas Leather Hand Gloves",
    productCategory: "Cotton Hand Gloves",
    series: "Leather Reinforced",
    tagline:
      "Canvas gloves with leather reinforcement for demanding industrial handling",
    image: IMG.canvasLeather,
    gallery: [IMG.canvasLeather],
    moq: "1 bag",
    pricePerPair: "Best Bulk Price",
    category: "Canvas Leather Hand Gloves",
    color: "",
    material: "Canvas Fabric / Leather",
    weight: "",
    sizes: [],
    applications: [
      "Material handling",
      "Industrial use",
      "Workshop operations",
    ],
    features: [
      "Canvas fabric construction",
      "Leather reinforcement",
    ],
    pack: "500 pairs / bag",
    leadTime: "Ask for availability",
  },

  // =========================================================
  // INDUSTRIAL COATED HAND GLOVES
  // =========================================================

  {
    slug: "commercial-grey-white",
    name: "Commercial Grey & White Hand Gloves",
    productCategory: "Industrial Coated Hand Gloves",
    series: "Commercial",
    tagline: "Commercial coated gloves for general industrial handling",
    image: IMG.commercialGreyWhite,
    gallery: [IMG.commercialGreyWhite],
    moq: "Ask for bulk quantity",
    pricePerPair: "Best Bulk Price",
    category: "Commercial Coated Gloves",
    color: "Grey & White",
    material: "Coated Fabric Glove",
    weight: "",
    sizes: [],
    applications: [
      "General material handling",
      "Warehouse work",
      "Industrial use",
      "Packing & handling",
    ],
    features: [
      "White glove with grey coating",
      "Coating on palm and fingers",
      "Commercial quality",
    ],
    pack: "Bulk packing",
    leadTime: "Ask for availability",
  },

  {
    slug: "commercial-orange-yellow",
    name: "Commercial Orange & Yellow Hand Gloves",
    productCategory: "Industrial Coated Hand Gloves",
    series: "Commercial",
    tagline: "Commercial coated gloves for general industrial handling",
    image: IMG.commercialOrangeYellow,
    gallery: [IMG.commercialOrangeYellow],
    moq: "Ask for bulk quantity",
    pricePerPair: "Best Bulk Price",
    category: "Commercial Coated Gloves",
    color: "Orange & Yellow",
    material: "Coated Fabric Glove",
    weight: "",
    sizes: [],
    applications: [
      "General material handling",
      "Warehouse work",
      "Industrial use",
      "Packing & handling",
    ],
    features: [
      "Yellow glove with orange coating",
      "Coating on palm and fingers",
      "Commercial quality",
    ],
    pack: "Bulk packing",
    leadTime: "Ask for availability",
  },

  {
  slug: "spectrum-vira-n-prime",
  name: "VIRA N-PRIME Nitrile Coated Gloves",
  productCategory: "Industrial Coated Hand Gloves",
  brand: "Spectrum",
  series: "Industrial Coated",
  tagline: "CR-1 nitrile coated industrial hand gloves",
  image: "/images/products/spectrum-vira-n-prime.webp",
  gallery: ["/images/products/spectrum-vira-n-prime.webp"],

  moq: "Bulk Orders",
  pricePerPair: "Best Bulk Price",

  category: "Industrial Coated Hand Gloves",
  cutResistance: "CR-1",

  material: "PET liner with Nitrile coating",
  liner: "PET",
  gauge: "13g",

  color: "White / Black liner Â· Grey / Blue / Black coating",
  linerColor: "White, Black",
  coatingColor: "Grey, Blue, Black",

  length: "230 to 275 mm",
  sizes: ["8", "9", "10"],
  coatingStyle: ["Â½", "3/4th", "Full", "Double"],

  en388: "4 1 2 1 X X",

  applications: [
    "Metal industry",
    "Automotive",
    "Engineering",
    "Electrical",
    "Material handling",
  ],

  features: [
    "Excellent chemical resistance",
    "Good oil repellency and slip resistance",
    "Knit wrist helps prevent dirt and debris from entering the glove",
    "Seamless knit liner for comfort, finger dexterity and breathability",
  ],

  pack: "Bulk industrial packing",
  leadTime: "Contact for availability",
},

{
  slug: "spectrum-soma",
  name: "SOMA Nitrile Coated Gloves",
  productCategory: "Industrial Coated Hand Gloves",
  brand: "Spectrum",
  series: "Industrial Coated",
  tagline: "CR-2 nitrile coated industrial hand gloves",
  image: "/images/products/spectrum-soma.webp",
  gallery: ["/images/products/spectrum-soma.webp"],

  moq: "Bulk Orders",
  pricePerPair: "Best Bulk Price",

  category: "Industrial Coated Hand Gloves",
  cutResistance: "CR-2",

  material: "HT-PET, Polyamide liner with Nitrile coating",
  liner: "HT-PET, Polyamide",
  gauge: "13g",

  color: "Shimmer Black liner Â· Black coating",
  linerColor: "Shimmer Black",
  coatingColor: "Black",

  length: "230 to 275 mm",
  sizes: ["8", "9", "10"],
  coatingStyle: ["Â½", "3/4th", "Full", "Double"],

  en388: "4 2 2 1 X X",

  applications: [
    "Metal industry",
    "Automotive",
    "Engineering",
    "Electrical",
    "Material handling",
  ],

  features: [
    "Excellent chemical resistance",
    "Good oil repellency and slip resistance",
    "Knit wrist helps prevent dirt and debris from entering the glove",
    "Seamless knit liner for comfort, finger dexterity and breathability",
  ],

  pack: "Bulk industrial packing",
  leadTime: "Contact for availability",
},

{
  slug: "spectrum-karveer",
  name: "KARVEER Nitrile Coated Gloves",
  productCategory: "Industrial Coated Hand Gloves",
  brand: "Spectrum",
  series: "Industrial Coated",
  tagline: "CR-3 nitrile coated industrial hand gloves",
  image: "/images/products/spectrum-karveer.webp",
  gallery: ["/images/products/spectrum-karveer.webp"],

  moq: "Bulk Orders",
  pricePerPair: "Best Bulk Price",

  category: "Industrial Coated Hand Gloves",
  cutResistance: "CR-3",

  material: "HT-PET, Inorganic fiber liner with Nitrile coating",
  liner: "HT-PET, Inorganic fiber",
  gauge: "13g",

  color: "Green liner Â· Grey / Black coating",
  linerColor: "Green",
  coatingColor: "Grey, Black",

  length: "230 to 275 mm",
  sizes: ["8", "9", "10"],
  coatingStyle: ["Â½", "3/4th", "Full", "Double"],

  en388: "3 3 4 2 B X",

  applications: [
    "Metal industry",
    "Automotive",
    "Engineering",
    "Electrical",
    "Material handling",
  ],

  features: [
    "Excellent chemical resistance",
    "Good oil repellency and slip resistance",
    "Knit wrist helps prevent dirt and debris from entering the glove",
    "Seamless knit liner for comfort, finger dexterity and breathability",
  ],

  pack: "Bulk industrial packing",
  leadTime: "Contact for availability",
},

{
  slug: "spectrum-ballad",
  name: "BALLAD Nitrile Coated Gloves",
  productCategory: "Industrial Coated Hand Gloves",
  brand: "Spectrum",
  series: "Industrial Coated",
  tagline: "CR-4 nitrile coated industrial hand gloves",
  image: "/images/products/spectrum-ballad.webp",
  gallery: ["/images/products/spectrum-ballad.webp"],

  moq: "Bulk Orders",
  pricePerPair: "Best Bulk Price",

  category: "Industrial Coated Hand Gloves",
  cutResistance: "CR-4",

  material: "UHMWPE, Inorganic fiber liner with Nitrile coating",
  liner: "UHMWPE, Inorganic fiber",
  gauge: "13g",

  color: "Blue liner Â· Grey / Black coating",
  linerColor: "Blue",
  coatingColor: "Grey and Black",

  length: "230 to 275 mm",
  sizes: ["8", "9", "10"],
  coatingStyle: ["Â½", "3/4th", "Full", "Double"],

  en388: "3 4 4 4 C X",

  applications: [
    "Metal industry",
    "Automotive",
    "Engineering",
    "Electrical",
    "Material handling",
  ],

  features: [
    "Excellent chemical resistance",
    "Good oil repellency and slip resistance",
    "Knit wrist helps prevent dirt and debris from entering the glove",
    "Seamless knit liner for comfort, finger dexterity and breathability",
  ],

  pack: "Bulk industrial packing",
  leadTime: "Contact for availability",
},

{
  slug: "spectrum-chola",
  name: "CHOLA Nitrile Coated Gloves",
  productCategory: "Industrial Coated Hand Gloves",
  brand: "Spectrum",
  series: "Industrial Coated",
  tagline: "CR-5 nitrile coated industrial hand gloves",
  image: "/images/products/spectrum-chola.webp",
  gallery: ["/images/products/spectrum-chola.webp"],

  moq: "Bulk Orders",
  pricePerPair: "Best Bulk Price",

  category: "Industrial Coated Hand Gloves",
  cutResistance: "CR-5",

  material: "UHMWPE, Inorganic fiber liner with Nitrile coating",
  liner: "UHMWPE, Inorganic fiber",
  gauge: "13g",

  color: "Bluish Grey liner Â· Grey / Black coating",
  linerColor: "Bluish Grey",
  coatingColor: "Grey and Black",

  length: "230 to 275 mm",
  sizes: ["8", "9", "10"],
  coatingStyle: ["Â½", "3/4th", "Full", "Double"],

  en388: "4 5 4 4 D X",

  applications: [
    "Metal industry",
    "Automotive",
    "Engineering",
    "Electrical",
    "Material handling",
  ],

  features: [
    "Excellent chemical resistance",
    "Good oil repellency and slip resistance",
    "Knit wrist helps prevent dirt and debris from entering the glove",
    "Seamless knit liner for comfort, finger dexterity and breathability",
  ],

  pack: "Bulk industrial packing",
  leadTime: "Contact for availability",
},

{
  slug: "spectrum-deva",
  name: "DEVA Nitrile Coated Gloves",
  productCategory: "Industrial Coated Hand Gloves",
  brand: "Spectrum",
  series: "Industrial Coated",
  tagline: "CR-F nitrile coated industrial hand gloves",
  image: "/images/products/spectrum-deva.webp",
  gallery: ["/images/products/spectrum-deva.webp"],

  moq: "Bulk Orders",
  pricePerPair: "Best Bulk Price",

  category: "Industrial Coated Hand Gloves",
  cutResistance: "CR-F",

  material: "UHMWPE, Steel Wire liner with Nitrile coating",
  liner: "UHMWPE, Steel Wire",
  gauge: "13g",

  color: "Dark Grey liner Â· Grey / Black coating",
  linerColor: "Dark Grey",
  coatingColor: "Grey and Black",

  length: "230 to 275 mm",
  sizes: ["8", "9", "10"],
  coatingStyle: ["Â½", "3/4th", "Full", "Double"],

  en388: "3 5 4 4 F X",

  applications: [
    "Metal industry",
    "Automotive",
    "Engineering",
    "Electrical",
    "Material handling",
  ],

  features: [
    "Excellent chemical resistance",
    "Good oil repellency and slip resistance",
    "Knit wrist helps prevent dirt and debris from entering the glove",
    "Seamless knit liner for comfort, finger dexterity and breathability",
  ],

  pack: "Bulk industrial packing",
  leadTime: "Contact for availability",
},
];

export const SERIES_LIST = [
  { name: "Lightweight", description: "Daily use & general work" },
  { name: "Heavy-Duty", description: "Rugged industrial protection" },
  { name: "Premium", description: "Flagship virgin-rubber range" },
  { name: "Everyday", description: "Economical workhorse" },
];

export const PRODUCT_CATEGORIES = [
  {
    name: "Rubber Hand Gloves",
    slug: "rubber-hand-gloves",
    description:
      "Durable, reliable protection for industrial, commercial and everyday use.",
  },
  {
    name: "Cotton Hand Gloves",
    slug: "cotton-hand-gloves",
    description:
      "Comfortable and versatile hand protection for multiple applications.",
  },
  {
    name: "Industrial Coated Hand Gloves",
    slug: "industrial-coated-hand-gloves",
    description:
      "Strong grip, superior performance and advanced industrial protection.",
  },
];

export const findProduct = (slug) =>
  PRODUCTS.find((p) => p.slug === slug);

